module.exports = {"TXTCLI_TelephoneX":{"id":"TXTCLI_TelephoneX","defaultMessage":"Τηλέφωνο:"}}